<template>
  <div>
      <div class="abc"  v-for="(url,i) in imgs">
        <img preview="1" preview-text="" :src="url" alt="">
                <span class="page">{{i + 1}}/{{imgs.length}}</span>

    </div>

    <div class="abc">

      <div >
        <div  >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Bus from '../bus'
  export default {
    data() {
      return {
        activeIndex: 0,
        i: 0,
        // imgs: [],
        dayHeight: 0,
        pptShow: true,
        pptTitle: '' //PPT标题
      }
    },
    props: {
      imgs: {
        type: Array,
      },
      conresource: {
        type: Array,
      },

    },
    methods: {
      /**
       * 监听滚动事件；使图片按需加载
       */
      listenScroll() {
        let scrollBox = document.querySelector('#scrollBox');
        let scrollHeight = scrollBox.offsetHeight;
        scrollBox.addEventListener('scroll', () => {
          let ppt = document.querySelector('#ppt');
          let imgs = ppt.querySelectorAll('img');
          let scrollTop = scrollBox.scrollTop;
//                    if (this.activeTab === 1) {
          Array.from(imgs).forEach((item, i) => {
            let top = item.offsetTop - 317 - scrollTop;
            if (top > scrollHeight) {
              return;
            } else {
              let src = item.getAttribute('data-src');
              item.setAttribute('src', src);
            }
          })
//                    }
        })
      },
      //显示具体PPT图片
      showPpt(obj) {
        this.$emit("goLogin");
        this.pptShow = false;
        this.pptTitle = obj.crTitle;
        //图片开始计数1；
        let num = 1;
        //总共有多少张
        let crPptsum = obj.crPptsum;
        //图片路径
        let crPptdir = obj.crPptdir;
        //图片后缀
        let crPptpostfix = obj.crPptpostfix;
        let imgs = [];
        for (let j = 1; j <= crPptsum; j++) {
          //console.log(crPptdir,crPptpostfix,crPptsum);
          let postfix = crPptpostfix.replace('#num#', j);
          let imgUrl = crPptdir + postfix;
          //console.log(imgUrl)
          imgs.push(imgUrl);
        }
        this.imgs = imgs;

        setTimeout(()=>{

        },5000)
        // this.listenScroll();
      },
      backPpt() {
        this.pptShow = true;
        let scrollBox = document.querySelector('#scrollBox');
        scrollBox.scrollTop = 0;
      }
    },
    mounted() {
        //      setTimeout(()=>{
                  //  this.$previewRefresh()
        // },5000)




    }
  }
</script>
<style scoped>
   .abc {
     position: relative;
   }
  .abc img{
    display: block;
    width: 7rem;
    margin: 0.25rem;
  }
  .page {
    display: block;
    text-align: center;
    width: .8rem;
    height: .4rem;
    line-height: 0.4rem;
    border: 0;
    background-color: #000;
    opacity: 0.5;
    color: #FFF;
    border-radius: .1rem;
    font-size: .26rem;
    position: absolute;
    z-index: 1000;
    /* margin-top: .2rem; */
    right: .65rem;
    top: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/container/photo.vue